import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconReconciliation = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.5 7.5H5M6.75 7.5H8.25M3.5 10H5M6.75 10H8.25M3.5 12.5H5M6.75 12.5H8.25M10 7.5H11.5M10 10H11.5M10 12.5H11.5M1.5 0.5H13.5V14.5H1.5V0.5ZM3.5 2.5H11.5V5.5H3.5V2.5Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgIconReconciliation;
